export const validateShowroomPageEdit = ({
  hasPermissionToEdit,
  teamBrandId,
  brandShowroomId,
}: {
  hasPermissionToEdit: boolean;
  brandShowroomId?: string;
  teamBrandId?: string;
}) => hasPermissionToEdit && teamBrandId === brandShowroomId;
